<template>
  <div>
    <!-- ============================================================== -->
    <!-- Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <div class="page-breadcrumb border-bottom">
      <div class="row">
        <div class="col-lg-3 col-md-4 col-xs-12 align-self-center">
          <h5 class="font-medium text-uppercase mb-0">Team Managers <span class="badge badge-primary">{{count}}</span></h5>
        </div>
        <div class="col-lg-9 col-md-8 col-xs-12 align-self-center">
          <button
            class="btn btn-primary text-white float-right ml-3 d-none d-md-block"
            @click="addTeam"
          >
            <i class="fas fa-plus"></i> Add team
          </button>
          <nav aria-label="breadcrumb" class="mt-2 float-md-right float-left">
            <ol class="breadcrumb mb-0 justify-content-end p-0">
              <li class="breadcrumb-item">
                <a>Home</a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">Team Managers</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="page-content container-fluid">
      <!-- ============================================================== -->
      <!-- Start Page Content -->
      <!-- ============================================================== -->

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="form-group col-4">
                  <div class="input-group">
                    <span class="input-group-btn">
                      <button type="button" class="btn waves-effect waves-light btn-info">
                        <i class="fa fa-search"></i>
                      </button>
                    </span>
                    <input v-model="textSearch" type="text" class="form-control" placeholder="Search by email" @change="searchTeam()"/>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <div class="text-center">
                  <i v-if="isLoading" class="fa fa-spinner fa-spin"></i>
                </div>
                <table class="table">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Name</th>
                      <th>Created From</th>
                      <th>Created At</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in items"
                      :key="index"
                      class="pointer"
                      @click="openDetailTeam(item)"
                    >
                      <td>{{item.id}}</td>
                      
                      <td style="inline-size: 30rem; overflow: hidden;">
                        {{item.name}}
                        <span v-if="item.hasSalesContract" class="badge badge-success ml-2">Enterprise</span>
                      </td>
                      <td>{{item.createdFrom || 'admin'}}</td>
                      <td>{{item.createdAt | dateTime}}</td>
                    </tr>
                  </tbody>
                </table>

                <div class="overflow-auto">
                  <b-pagination v-model="page" :total-rows="count" per-page="100"></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Config from "@/config"
import AccountsAPI from "@/api/accounts"

export default {
  name: "Users",
  data() {
    return {
      items: [],
      page: 1,
      count: 0,
      isLoading: false,
      textSearch: "",
      selectedIdentifyProvider: null,
      options: [
        { value: null, text: 'All' },
        { value: 'skoletube', text: 'Skoletube' },
      ],
      salesContracts: [],
    }
  },
  created() {
    this.getData()
  },
  mounted() {},
  watch: {
    page: {
      handler: function() {
        this.getData()
      },
      deep: true
    }
  },
  methods: {
    searchTeam () {
      this.getData()
    },
    async getData() {
      this.isLoading = true
      this.$http
        .get(Config.api.getListAccount, {
          params: {
            page: this.page,
            textSearch: this.textSearch,
          }
        })
        .then(async res => {
          this.isLoading = false
          this.items = res.body.result
          this.count = res.body.count
          
          // Get sales-assisted-contract data
          await this.getSalesContracts()
        })
    },
    async getSalesContracts() {
      if (this.items.length === 0) return
      
      try {
        // Extract account IDs from items
        const accountIds = this.items.map(item => item.id)
        
        // Call the sales-assisted-contract API
        const salesContracts = await AccountsAPI.getSalesAssistedContract({ accountIds })
        
        // Merge sales data with items
        this.items = this.items.map(item => {
          const hasContract = salesContracts.some(contract => contract.teamid === item.id)
          return {
            ...item,
            hasSalesContract: hasContract
          }
        })
      } catch (error) {
        console.error('Error fetching sales contracts:', error)
      }
    },
    openDetailTeam(item) {
      this.$router.push({ name: "TeamDetail", params: { id: item.id } })
    },
    addTeam() {
      this.$router.push({ name: "TeamDetail", params: { id: "new" } })
    },
  }
}
</script>
<style lang="scss" scoped>
// .addUser-btn {
//   background-color: #4f9af2;
//   border-radius: 20px;
//   border-color: #4f9af2;
//   &:hover {
//     background-color: #2785f0;
//     border-color: #2785f0;
//   }
// }
</style>
